import { render, staticRenderFns } from "./ThirdSectionMaskExCard.vue?vue&type=template&id=4b227338&scoped=true&"
import script from "./ThirdSectionMaskExCard.vue?vue&type=script&lang=js&"
export * from "./ThirdSectionMaskExCard.vue?vue&type=script&lang=js&"
import style0 from "./ThirdSectionMaskExCard.vue?vue&type=style&index=0&id=4b227338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b227338",
  null
  
)

export default component.exports